import { NewRelicPlusPlugin, EventType, ElementType, EventAction } from '@cof/stratum';

const PLUGINS = [NewRelicPlusPlugin()];
// PRODUCT_NAME is a required export of this file (use your DevNav component name)
const PRODUCT_NAME = 'fs-offers-mfe-staticassets';
// PRODUCT_VERSION is a required export of this file
const PRODUCT_VERSION = '1.1.6';
var TagKey;
(function (TagKey) {
    /**
     * Enumerate keys of tag catalog entries here for easy
     * use and consistent reference across your application.
     *
     * The values of the tag keys can be any string or number
     * value. These keys will not be referenced outside
     * of the application.
     */
    TagKey["PAGE_VIEW_COAF_REFI_OFFERS"] = "PAGE_VIEW_COAF_REFI_OFFERS";
    TagKey["OFFERS_SELECTED_OFFER"] = "OFFERS_SELECTED_OFFER";
    TagKey["PAGE_VIEW_COAF_REFI_BUILDYOUROFFER"] = "PAGE_VIEW_COAF_REFI_BUILDYOUROFFER";
    TagKey["BUILD_YOUR_OFFER_BYO_COMPARE_TO_ORIGINAL"] = "BUILD_YOUR_OFFER_BYO_COMPARE_TO_ORIGINAL";
    TagKey["VIEW_BUILD_YOUR_OFFER"] = "VIEW_BUILD_YOUR_OFFER";
    TagKey["BUILD_YOUR_OFFER_MONTHLY_PAYMENT_INPUT"] = "BUILD_YOUR_OFFER_MONTHLY_PAYMENT_INPUT";
    TagKey["BUILD_YOUR_OFFER_TERM_INPUT"] = "BUILD_YOUR_OFFER_TERM_INPUT";
    TagKey["BUILD_YOUR_OFFER_DECREASE_PAYMENT_INPUT"] = "BUILD_YOUR_OFFER_DECREASE_PAYMENT_INPUT";
    TagKey["BUILD_YOUR_OFFER_INCREASE_PAYMENT_INPUT"] = "BUILD_YOUR_OFFER_INCREASE_PAYMENT_INPUT";
    TagKey["BUILD_YOUR_OFFER_DECREASE_TERM_INPUT"] = "BUILD_YOUR_OFFER_DECREASE_TERM_INPUT";
    TagKey["BUILD_YOUR_OFFER_INCREASE_TERM"] = "BUILD_YOUR_OFFER_INCREASE_TERM";
    TagKey["BUILD_YOUR_OFFER_PRE_MADE_OPTION_DROPDOWN"] = "BUILD_YOUR_OFFER_PRE_MADE_OPTION_DROPDOWN";
    TagKey["BUILD_YOUR_OFFER_PRE_MADE_SAME_TERM"] = "BUILD_YOUR_OFFER_PRE_MADE_SAME_TERM";
    TagKey["BUILD_YOUR_OFFER_PRE_MADE_SHORTEST_TERM"] = "BUILD_YOUR_OFFER_PRE_MADE_SHORTEST_TERM";
    TagKey["BUILD_YOUR_OFFER_PRE_MADE_LONGEST_TERM"] = "BUILD_YOUR_OFFER_PRE_MADE_LONGEST_TERM";
    TagKey["PAGE_VIEW_COAF_REFI_SHOPPER"] = "PAGE_VIEW_COAF_REFI_SHOPPER";
    TagKey["SHOPPER_SHOPPER_COMPARE_TO_ORIGINAL"] = "SHOPPER_SHOPPER_COMPARE_TO_ORIGINAL";
    TagKey["VIEW_SHOPPER"] = "VIEW_SHOPPER";
    TagKey["SHOPPER_SHORTEST_TERM_SELECTED"] = "SHOPPER_SHORTEST_TERM_SELECTED";
    TagKey["SHOPPER_SHORTEN_TERM_SELECTED"] = "SHOPPER_SHORTEN_TERM_SELECTED";
    TagKey["SHOPPER_SAME_TERM_SELECTED"] = "SHOPPER_SAME_TERM_SELECTED";
    TagKey["SHOPPER_LONGER_TERM_SELECTED"] = "SHOPPER_LONGER_TERM_SELECTED";
    TagKey["SHOPPER_LONGEST_TERM_SELECTED"] = "SHOPPER_LONGEST_TERM_SELECTED";
    TagKey["BUILD_YOUR_OFFER_EXIT_COMPARISON_MODAL"] = "BUILD_YOUR_OFFER_EXIT_COMPARISON_MODAL";
    TagKey["CHECKOUT_PAGE_OFFER_CARD_LOAD"] = "CHECKOUT_PAGE_OFFER_CARD_LOAD";
    TagKey["PAGE_VIEW_COAF_REFI_OFFERS_APPROVED"] = "PAGE_VIEW_COAF_REFI_OFFERS_APPROVED";
    TagKey["APR_INTERSTITIAL_SEE_MY_OFFERS"] = "APR_INTERSTITIAL_SEE_MY_OFFERS";
    TagKey["APR_INTERSTITIAL_APR_INTERSTITIAL_VALUES"] = "APR_INTERSTITIAL_APR_INTERSTITIAL_VALUES";
    TagKey["ANNUAL_SAVINGS_BANNER_ANNUAL_SAVINGS_VALUES"] = "ANNUAL_SAVINGS_BANNER_ANNUAL_SAVINGS_VALUES";
})(TagKey || (TagKey = {}));
// TAG_CATALOG is a required export of this file
const TAG_CATALOG = {
    /**
     * Add TagCatalog entries here. Best practice
     * is to use enumerated values for the tag keys.
     *
     * For properties with values of a specific type (like eventType),
     * export the corresponding type from the @cof/stratum package.
     */
    [TagKey.PAGE_VIEW_COAF_REFI_OFFERS]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Offers Page viewed',
        tagId: 5001,
        rules: {
            applicationId: true,
        },
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'offers',
            level4: '',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.OFFERS_SELECTED_OFFER]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Continue" button on a offer card to select the offer',
        tagId: 5002,
        rules: {
            applicationId: true,
        },
        featureName: 'Offers',
        tagName: 'selected offer',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.PAGE_VIEW_COAF_REFI_BUILDYOUROFFER]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'BYO Experience Viewed',
        tagId: 5003,
        rules: {
            applicationId: true,
        },
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'buildyouroffer',
            level4: '',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.BUILD_YOUR_OFFER_BYO_COMPARE_TO_ORIGINAL]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Compare this to your original loan" in BYO',
        tagId: 5004,
        rules: {
            applicationId: true,
        },
        featureName: 'Build Your Offer',
        tagName: 'byo compare to original',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.VIEW_BUILD_YOUR_OFFER]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Compare to original loan modal viewed in BYO',
        tagId: 5005,
        rules: {
            applicationId: true,
        },
        featureName: 'Build Your Offer',
    },
    [TagKey.BUILD_YOUR_OFFER_MONTHLY_PAYMENT_INPUT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Monthly payment" input option in BYO',
        tagId: 5006,
        rules: {
            applicationId: true,
        },
        featureName: 'Build Your Offer',
        tagName: 'monthly payment input',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.BUILD_YOUR_OFFER_TERM_INPUT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Term" input option in BYO',
        tagId: 5007,
        rules: {
            applicationId: true,
        },
        featureName: 'Build Your Offer',
        tagName: 'term input',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.BUILD_YOUR_OFFER_DECREASE_PAYMENT_INPUT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "-" to decrease payment input in BYO',
        tagId: 5008,
        rules: {
            applicationId: true,
        },
        featureName: 'Build Your Offer',
        tagName: 'decrease payment input',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.BUILD_YOUR_OFFER_INCREASE_PAYMENT_INPUT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "+" to increase payment input in BYO',
        tagId: 5009,
        rules: {
            applicationId: true,
        },
        featureName: 'Build Your Offer',
        tagName: 'increase payment input',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.BUILD_YOUR_OFFER_DECREASE_TERM_INPUT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "-" to decrease term input in BYO',
        tagId: 5010,
        rules: {
            applicationId: true,
        },
        featureName: 'Build Your Offer',
        tagName: 'decrease term input',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.BUILD_YOUR_OFFER_INCREASE_TERM]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "+" to increase term input in BYO',
        tagId: 5011,
        rules: {
            applicationId: true,
        },
        featureName: 'Build Your Offer',
        tagName: 'increase term',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.BUILD_YOUR_OFFER_PRE_MADE_OPTION_DROPDOWN]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Or choose from these pre-made options" in BYO',
        tagId: 5012,
        rules: {
            applicationId: true,
        },
        featureName: 'Build Your Offer',
        tagName: 'pre-made option dropdown',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.BUILD_YOUR_OFFER_PRE_MADE_SAME_TERM]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks same term option in pre-made options drop down in BYO',
        tagId: 5013,
        rules: {
            applicationId: true,
        },
        featureName: 'Build Your Offer',
        tagName: 'pre-made same term',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.BUILD_YOUR_OFFER_PRE_MADE_SHORTEST_TERM]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks shortest term option in pre-made options drop down in BYO',
        tagId: 5014,
        rules: {
            applicationId: true,
        },
        featureName: 'Build Your Offer',
        tagName: 'pre-made shortest term',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.BUILD_YOUR_OFFER_PRE_MADE_LONGEST_TERM]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks longest term option in pre-made options drop down in BYO',
        tagId: 5015,
        rules: {
            applicationId: true,
        },
        featureName: 'Build Your Offer',
        tagName: 'pre-made longest term',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.PAGE_VIEW_COAF_REFI_SHOPPER]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Shopper Experience Viewed',
        tagId: 5016,
        rules: {
            applicationId: true,
        },
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'shopper',
            level4: '',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.SHOPPER_SHOPPER_COMPARE_TO_ORIGINAL]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Compare this to your original loan" in Shopper',
        tagId: 5017,
        rules: {
            applicationId: true,
        },
        featureName: 'Shopper',
        tagName: 'shopper compare to original',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.VIEW_SHOPPER]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Compare to original loan modal viewed in Shopper',
        tagId: 5018,
        rules: {
            applicationId: true,
        },
        featureName: 'Shopper',
    },
    [TagKey.SHOPPER_SHORTEST_TERM_SELECTED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks shortest term option in Shopper',
        tagId: 5019,
        rules: {
            applicationId: true,
        },
        featureName: 'Shopper',
        tagName: 'shortest term selected',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.SHOPPER_SHORTEN_TERM_SELECTED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks shorten term option in Shopper',
        tagId: 5020,
        rules: {
            applicationId: true,
        },
        featureName: 'Shopper',
        tagName: 'shorten term selected',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.SHOPPER_SAME_TERM_SELECTED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks same term option in Shopper',
        tagId: 5021,
        rules: {
            applicationId: true,
        },
        featureName: 'Shopper',
        tagName: 'same term selected',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.SHOPPER_LONGER_TERM_SELECTED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks longer term option in Shopper',
        tagId: 5022,
        rules: {
            applicationId: true,
        },
        featureName: 'Shopper',
        tagName: 'longer term selected',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.SHOPPER_LONGEST_TERM_SELECTED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks longest term option in Shopper',
        tagId: 5023,
        rules: {
            applicationId: true,
        },
        featureName: 'Shopper',
        tagName: 'longest term selected',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.BUILD_YOUR_OFFER_EXIT_COMPARISON_MODAL]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "x" or "okay" in comparison modal in Shopper or BYO',
        tagId: 5024,
        rules: {
            applicationId: true,
        },
        featureName: 'Build Your Offer',
        tagName: 'exit comparison modal',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.CHECKOUT_PAGE_OFFER_CARD_LOAD]: {
        eventType: EventType.UI,
        tagDescription: 'Checkout Page loads Offers MFE (values for offer details) ',
        tagId: 5025,
        featureName: 'Checkout Page',
        tagName: 'offer card load',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.PAGE_VIEW_COAF_REFI_OFFERS_APPROVED]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'APR Interstitial page viewed',
        tagId: 5026,
        rules: {
            applicationId: true,
        },
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'offers',
            level4: 'approved',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.APR_INTERSTITIAL_SEE_MY_OFFERS]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "See my offers" on the APR interstitial ',
        tagId: 5027,
        rules: {
            applicationId: true,
        },
        featureName: 'APR Interstitial',
        tagName: 'see my offers',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.APR_INTERSTITIAL_APR_INTERSTITIAL_VALUES]: {
        eventType: EventType.UI,
        tagDescription: 'APR Interstitial values',
        tagId: 5028,
        rules: {
            applicationId: true,
        },
        featureName: 'APR Interstitial',
        tagName: 'apr interstitial values',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.ANNUAL_SAVINGS_BANNER_ANNUAL_SAVINGS_VALUES]: {
        eventType: EventType.UI,
        tagDescription: 'Annual Savings Banner Values',
        tagId: 5029,
        rules: {
            applicationId: true,
        },
        featureName: 'Annual Savings Banner',
        tagName: 'annual savings values',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
};

export { PLUGINS, PRODUCT_NAME, PRODUCT_VERSION, TAG_CATALOG, TagKey };
